import React, { useEffect } from 'react';
import { Container, Grid } from '@mantine/core';
import { useLocation, useNavigate, type Location } from 'react-router-dom';
import { useAuth } from 'hooks/useAuth';
import LeftSection from 'modules/pages/login/LeftSection';
import RightSection from 'modules/pages/login/RightSection';

const LoginPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { profile } = useAuth();
  const fromLocation = (location.state as { from?: Location } | null)?.from;
  const redirectTo = fromLocation
    ? `${fromLocation.pathname}${fromLocation.search}${fromLocation.hash}`
    : '/';

  useEffect(() => {
    if (profile) {
      navigate(redirectTo, { replace: true });
    }
  }, [profile, redirectTo, navigate]);

  return (
    <Container fluid size='xs' py='xl' h={'100vh'}>
      <Grid
        h={{ base: 'auto', md: '100%' }}
        styles={{
          inner: {
            height: '100%'
          }
        }}
      >
        <Grid.Col span={{ base: 0, md: 6 }}>
          <LeftSection />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 6 }}>
          <RightSection redirectTo={redirectTo} />
        </Grid.Col>
      </Grid>
    </Container>
  );
};

export default LoginPage;
